import { AVATARS } from "../lib/constants";
import { FRAMES } from "../lib/shop";

export const Logo = ({ className = "" }) => (
  <span data-testid="zunii-logo" className={`font-display font-bold text-3xl tracking-tight inline-flex items-center gap-1 ${className}`}>
    <span className="inline-grid place-items-center w-10 h-10 rounded-2xl bg-[#FF6B4A] border-[3px] border-[#1B1A2E] text-white -rotate-6 shadow-[3px_3px_0_0_#1B1A2E]">Z</span>
    <span>unii</span>
    <span className="w-2.5 h-2.5 rounded-full bg-[#FFD23F] border-2 border-[#1B1A2E] -mt-5" />
  </span>
);

const BareAvatar = ({ Icon, color, size, className = "", border = "border-[3px]" }) => (
  <span
    className={`inline-grid place-items-center rounded-full ${border} border-[#1B1A2E] shrink-0 ${className}`}
    style={{ width: size, height: size, background: color || "#FFD23F" }}
  >
    <Icon size={size * 0.5} strokeWidth={2.5} color="#1B1A2E" />
  </span>
);

export const KidAvatar = ({ avatar, color, frame, size = 56, className = "" }) => {
  const Icon = AVATARS[avatar] || AVATARS.star;
  const f = FRAMES[frame];
  if (f) {
    const ring = Math.max(3, Math.round(size * 0.1));
    const Deco = f.deco;
    const inner = size - ring * 2 - 6;
    return (
      <span data-testid={`avatar-frame-${f.id}`} className={`relative inline-grid place-items-center rounded-full border-[3px] border-[#1B1A2E] shrink-0 ${className}`}
        style={{ width: size, height: size, background: f.bg, padding: ring }}>
        <BareAvatar Icon={Icon} color={color} size={inner} border="border-2" />
        {size >= 40 && (
          <span className="absolute -top-1 -right-1 grid place-items-center rounded-full border-2 border-[#1B1A2E]" style={{ width: size * 0.32, height: size * 0.32, background: f.decoBg }}>
            <Deco size={size * 0.18} strokeWidth={2.5} color="#1B1A2E" />
          </span>
        )}
      </span>
    );
  }
  return <BareAvatar Icon={Icon} color={color} size={size} className={className} />;
};
